//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axios from 'axios'

export default {
    name: 'UserDropdown',

    data(){ return {
        showAppBar: false,
        horizontalFlow: false,
    }},

    computed: {
        user(){ return this.$store.getters['auth/user'] },
        userImage(){ return this.user.avatar ? this.user.avatar : 'https://cdn.quasar.dev/img/boy-avatar.png' },
        userName(){ return this.user.username ? this.user.username : this.user.name },
        horizontal(){ return this.horizontalFlow ? 'column' : 'row reverse' },
    },

    methods: {
        logout(){
            this.$store.dispatch('auth/logout')
        },

        login(){
            let href = window.location.href
            let auth = this.$root.config.api.login
            let go = auth + '?cb=' + href

            window.location = go
        }
    }
}
